var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5469 6.70215L10.6885 7.03516L11.0479 7.06641L15.0361 7.41211L12.0195 10.0283L11.7461 10.2646L11.8281 10.6162L12.7266 14.5039L9.30957 12.4424L9 12.2559L8.69043 12.4424L5.27246 14.5039L6.17188 10.6162L6.25391 10.2646L5.98047 10.0283L2.96289 7.41211L6.95215 7.06641L7.31152 7.03516L7.45312 6.70215L9 3.04102L10.5469 6.70215Z",
    stroke: "currentColor",
    strokeWidth: 1.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarOutlined);
export default __webpack_public_path__ + "static/media/star_outlined.0e27b98c888636e3e9a6017bfe70cc40.svg";
export { ForwardRef as ReactComponent };